// Open Fibre packages
export const openFibrePackages = [
  {
    ID: 23559001,
    Title: "Open Fibre 50/50Mbps FTTH - Open Fibre By Wondernet",
    Price: 795.00,
    "Download speed (kbps)": 51200,
    "Upload speed (kbps)": 51200,
    Supplier: "Open Fibre",
    ISP: "Wondernet"
  },
  {
    ID: 23559002,
    Title: "Open Fibre 100/100Mbps FTTH - Open Fibre By Wondernet",
    Price: 995.00,
    "Download speed (kbps)": 102400,
    "Upload speed (kbps)": 102400,
    Supplier: "Open Fibre",
    ISP: "Wondernet"
  },
  {
    ID: 23559003,
    Title: "Open Fibre 200/200Mbps FTTH - Open Fibre By Wondernet",
    Price: 1195.00,
    "Download speed (kbps)": 204800,
    "Upload speed (kbps)": 204800,
    Supplier: "Open Fibre",
    ISP: "Wondernet"
  },
  {
    ID: 23559004,
    Title: "Open Fibre 1000/500Mbps FTTH - Open Fibre By Wondernet",
    Price: 1395.00,
    "Download speed (kbps)": 1024000,
    "Upload speed (kbps)": 512000,
    Supplier: "Open Fibre",
    ISP: "Wondernet"
  },
  {
    ID: 22559906,
    Title: "OpenFibre 20/5Mbps FTTH - Open Fibre By Wondernet",
    Price: 695.00,
    "Download speed (kbps)": 20480,
    "Upload speed (kbps)": 5120,
    Supplier: "Open Fibre",
    ISP: "Wondernet"
  },
  {
    ID: 22559907,
    Title: "OpenFibre 50/50Mbps FTTH - Open Fibre By Wondernet",
    Price: 795.00,
    "Download speed (kbps)": 51200,
    "Upload speed (kbps)": 51200,
    Supplier: "Open Fibre",
    ISP: "Wondernet"
  },
  {
    ID: 22559908,
    Title: "OpenFibre 100/100Mbps FTTH - Open Fibre By Wondernet",
    Price: 995.00,
    "Download speed (kbps)": 102400,
    "Upload speed (kbps)": 102400,
    Supplier: "Open Fibre",
    ISP: "Wondernet"
  },
  {
    ID: 22559909,
    Title: "OpenFibre 200/200Mbps FTTH - Open Fibre By Wondernet",
    Price: 1195.00,
    "Download speed (kbps)": 204800,
    "Upload speed (kbps)": 204800,
    Supplier: "Open Fibre",
    ISP: "Wondernet"
  },
  {
    ID: 22559910,
    Title: "OpenFibre 1000/500Mbps FTTH - Open Fibre By Wondernet",
    Price: 1495.00,
    "Download speed (kbps)": 1024000,
    "Upload speed (kbps)": 512000,
    Supplier: "Open Fibre",
    ISP: "Wondernet"
  }
];